import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "quotation-action-bar px-4 py-3",
  style: {"position":"fixed","bottom":"0","width":"100%","border":"1px solid #dadada","background":"#fff","z-index":"1"}
}

import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import QuotationConvertActionModal from "./QuotationConvertActionModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuotationConvertAction',
  props: {
    quotationId: {},
    onSuccess: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const modal = useModalStore();

function openModal() {
  modal.open(
    QuotationConvertActionModal,
    {
      quotationId: props.quotationId,
      onSuccess: props.onSuccess,
    },
    { maxWidth: 420, showHeader: false },
  );
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(AppButtonFlat, {
              size: "small",
              color: "success",
              block: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-check-circle-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[2] || (_cache[2] = _createTextVNode(" Convert to Appointment ", -1))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})